import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import DisplayContainer from "../../../../components/displayContainer/DisplayContainer";
import ImageUploader from "../../../../components/inputs/imageUploader/ImageUploader";
import Loader from "../../../../components/loader/Loader";
import TextWrapper from "../../../../components/textWrapper/TextWrapper";
import { fetchTournamentImages } from "../../../../features/images/tournamentImages/tournamentImagesSlice";
import styles from "./tournamentImages.module.css";
import TournamentOneImage from "./tournamentOneImage/TournamentOneImage";

const TournamentImages = () => {
  const dispatch = useDispatch();

  const {
    fetchStatus,
    deleteStatus,
    list: tournamentImages,
    uploadStatus,
  } = useSelector((state) => state.tournamentImages);

  useEffect(() => {
    if (fetchStatus === "idle") {
      dispatch(fetchTournamentImages());
    }
  }, [dispatch, fetchStatus]);

  if (
    fetchStatus === "loading" ||
    deleteStatus === "loading" ||
    uploadStatus === "loading"
  ) {
    return (
      <div className={styles.loaderContainer}>
        <Loader />
      </div>
    );
  }

  return (
    <div className={styles.container}>
      <div className={styles.headerRow}>
        <TextWrapper textStyle="textTitle">جميع صور البطولات</TextWrapper>
        <div className={styles.imageUploaderWrapper}>
          <ImageUploader tag={"tournament"} label="رفع صورة جديدة" />
        </div>
      </div>
      <div className={styles.allImagesWrapper}>
        <DisplayContainer className={styles.imagesDisplay}>
          {tournamentImages.map((item) => {
            return (
              <TournamentOneImage
                key={item._id}
                path={item.path}
                name={item.name}
                id={item._id}
              />
            );
          })}
        </DisplayContainer>
      </div>
    </div>
  );
};

export default TournamentImages;
